import React from 'react';
import * as styles from './HotkeyInfo.module.scss';
import { IS_APPLE } from '../constants/os';

export const SHORT_KEY = 'SHORT_KEY';

const KEY_MAP: Record<string, string> = {
  Enter: '⏎',
  [SHORT_KEY]: IS_APPLE ? '⌘' : 'Ctrl',
};

interface HotkeyInfoProps {
  keys: Set<string>;
  action?: string | undefined;
}

const HotkeyInfo = ({ keys, action }: HotkeyInfoProps) => {
  return (
    <span className={styles.hotkeyInfo}>
      {Array.from(keys.values()).map((key, i) => {
        return (
          <span key={key}>
            {i > 0 ? ' or ' : null}
            <kbd>{KEY_MAP[key] ?? key}</kbd>
          </span>
        );
      })}
      {action ? <span>to {action}</span> : null}
    </span>
  );
};

export default HotkeyInfo;
